import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    paths: [],
    theme: {},
    layout: 'index-layout',
    isBlocked: false,
    isMobile: false,
    activeRequests: 0,
    drawer: false,
    loading: false,
    empresa: null,
    user: null,
    logoutFunctions: null,
  },
  mutations: {
    paths (state, data) {
      state.paths = data
    },
    theme (state, data) {
      state.theme = data
    },
    isMobile (state) {
      state.isMobile = window.innerWidth < 960
    },
    drawer (state) {
      state.drawer = !state.drawer
    },
    addRequest (state) {
      state.activeRequests += 1
    },
    removeRequest (state) {
      state.activeRequests -= 1
      if (state.activeRequests < 0) { state.activeRequests = 0 }
    },
    empresa (state, empresa) {
      state.empresa = empresa
      localStorage.setItem('empresa', JSON.stringify(empresa))
    },
    user (state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_USER_DATA (state, data) {
      if (!data.user) { data.user = '' }

      state.user = data.user
      localStorage.setItem('user', JSON.stringify(data.user))
      localStorage.setItem('documento', data.user.documento)
      localStorage.setItem('status', 'loggedIn')
      axios.defaults.headers.common.Authorization = `Bearer ${data.user.token
        }`
    },
    CLEAR_USER_DATA (state) {
      if (state.logoutFunctions && state.logoutFunctions.beforeClear) { state.logoutFunctions.beforeClear(state) }
      localStorage.clear()
      localStorage.setItem('status', 'loggedOut')
      location.reload()
      if (state.logoutFunctions && state.logoutFunctions.afterClear) { state.logoutFunctions.afterClear(state) }
    },
    logoutFunctions (state, functions) {
      state.logoutFunctions = functions
    },
    SET_LAYOUT (state, payload) {
      state.layout = payload
    },
    loading (state, obj) {
      state.loading = obj
    }
  },
  actions: {
    setUserData ({ commit }, data) {
      commit('SET_USER_DATA', data)
    },
    logout ({ commit, state, dispatch }) {
      commit('CLEAR_USER_DATA')
    }
  },
  getters: {
    paths (state) {
      return state.paths
    },
    theme (state) {
      return state.theme
    },
    isMobile (state) {
      return state.isMobile
    },
    drawer (state) {
      return state.drawer
    },
    activeRequests (state) {
      return state.activeRequests
    },
    layout (state) {
      return state.layout
    },
    loggedIn (state) {
      return !!state.user
    },
    loading (state) {
      return state.loading
    },
    empresa (state) {
      if (!state.empresa) {
        if (localStorage.getItem('empresa')) {
          state.empresa = JSON.parse(localStorage.getItem('empresa'))
        }
      }
      return state.empresa
    },
    user (state) {
      if (!state.user) {
        if (localStorage.getItem('user')) {
          state.user = JSON.parse(localStorage.getItem('user'))
        }
      }

      if (!state.user) { state.user = {} }

      if (!state.user.profile) { state.user.profile = {} }

      return state.user
    },
    money () {
      return { precision: 2, decimal: ',', thousands: '.', prefix: '', suffix: '', masked: false }
    }
  }
})
